<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xml:space="preserve"
        :width="width"
        :height="height"
        version="1.1"
        style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
        viewBox="0 0 101 193"
        xmlns:xlink="http://www.w3.org/1999/xlink"
    >
        <path
            class="fil0 str1"
            d="M30 125l40 0c0,-1 0,-22 0,-23 0,-1 -1,-1 -1,-2 0,-1 0,-2 0,-3 0,-1 0,-3 0,-4 0,-1 0,-2 0,-3 0,-1 1,-1 2,-2 0,0 2,-2 2,-3 0,-1 -3,-3 -3,-4 0,0 0,-1 -1,-2 0,-1 0,-2 0,-3 0,-1 0,-2 1,-2 1,-1 4,-3 3,-5 0,-1 -2,-2 -3,-3 0,0 0,-1 0,-1 0,0 0,-1 0,-2 0,0 0,-1 0,-1 0,-1 0,-1 0,-2 0,-1 0,-1 0,-1 1,-2 4,-2 3,-5 0,-1 -3,-3 -4,-5 0,-1 0,-3 0,-4 0,-2 4,-3 4,-5 0,-4 -4,-4 -4,-9 0,-4 3,-4 3,-7 0,-3 -8,-15 -11,-18l-17 0c-2,1 -5,3 -7,5 -3,3 -4,8 -4,12 0,4 -4,5 -4,8 0,2 4,3 4,7 0,6 -4,6 -4,9 0,2 4,3 4,5 0,1 0,3 0,4 0,2 -4,4 -4,5 0,3 3,3 3,5 0,1 0,6 0,7 -1,1 -3,2 -3,3 0,2 2,3 3,5 1,1 1,5 0,6 -1,1 -3,3 -3,4 0,1 4,4 4,5 0,1 -3,2 -3,3 0,1 0,22 0,23zm41 -102c-11,1 -27,3 -39,7m39 8c-11,1 -26,3 -38,6m38 8c-10,1 -25,3 -38,6m37 8c-11,1 -25,3 -37,6m38 -43c-11,1 -26,3 -39,7m39 8c-11,1 -27,3 -39,7m39 8c-12,1 -27,3 -38,7m39 8c-13,1 -27,3 -39,7m39 0c-11,1 -25,3 -38,6m38 1c-11,1 -26,3 -38,7"
        />
        <path
            class="filWhite str1"
            d="M23 144c0,-23 17,-38 31,-38 14,0 30,20 29,43 2,18 -22,37 -34,37 -12,0 -26,-15 -26,-42z"
        />
    </svg>
</template>

<script>
import { toothMixins } from '@/mixins/tooth.js'
export default {
    mixins: [toothMixins]
}
</script>
